import { Variant } from '@collaborator/npm_modules/dist/css/variant';
import app from 'srcJs/App';
import { Alert } from 'ui/alert/Alert';
import * as React from 'react';
export var NotifyAlert = function NotifyAlert(_ref) {
  var onClose = _ref.onClose,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Alert, {
    variant: Variant.primary,
    dismissible: true,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, app.t('confirm_email_notifier', '👆Confirm Your Email.'), ' ', /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: "text-reset text-underline text-nowrap",
    onClick: onClick
  }, app.t('confirm_email_notifier', 'Resend confirmation email.'))));
};